module.exports = __webpack_public_path__ + "img/clint5.80fd4e80.png";